import React, { useEffect, useState } from "react";
import configData from "../config.json";
import { useMediaQuery } from "react-responsive";
import moment from "moment";
const base2 = `https://admin.myprega.com`;

const Reports = (props) => {
  const [medicalexperts, setMedicalexperts] = useState([]);
  const [allreports, setAllreports] = useState([]);
  const userId = localStorage.getItem("userId");
  const isTabScreen = useMediaQuery({
    query: "(min-width: 768px)" && "(max-width: 1023px)",
  });
  const [clr, setclr] = useState(false);
  const isTabScreen1 = useMediaQuery({
    query: "(min-width: 1024px)" && "(max-width: 1240px)",
  });
  const addtofav = () => {
    setclr(!clr);
  };
  function handleChange(e) {
    const { nodeName, value } = e.target;

    if (nodeName === "INPUT") {
      setRadio(value);
    }
  }

  useEffect(() => {
    setAllreports(props.allreports);
    const uniqueExperts = [];
    const seenExperts = new Set();

    // Loop through all reports to find unique medical experts by name only
    props.allreports.forEach((item) => {
      // If the medical_expert_name hasn't been added to the seenExperts set, add it
      if (!seenExperts.has(item.medical_expert_name)) {
        seenExperts.add(item.medical_expert_name);
        uniqueExperts.push({
          name: item.medical_expert_name,
          value: item.doctor_id, // Optionally add the first doctor_id you encounter
        });
      }
    });

    // Set the unique experts to the state
    setMedicalexperts(uniqueExperts);
  }, [props.allreports]);

  const filterreports = (id) => {
    if (id == "all") {
      setAllreports(props.allreports);
    } else {
      let currentreport = props.allreports.filter(
        (item) => item.doctor_id == id
      );
      setAllreports(currentreport);
    }
  };


  const [oldReports, setOldReports] = useState([]);
  const [reportType, setReportType] = useState("current"); 
  const [loadingOldReports, setLoadingOldReports] = useState(false);
  
  const fetchOldReports = async () => {
    try {
      setLoadingOldReports(true);
  
      const response = await fetch(
        `${base2}/user/get_previous_reports`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: patient_id,
          }),
        }
      );
  
      const result = await response.json();
  
      if (result?.status === "Success") {
        setOldReports(result?.data?.reports || []);
      } else {
        setOldReports([]);
      }
    } catch (error) {
      console.error("Old reports error:", error);
      setOldReports([]);
    } finally {
      setLoadingOldReports(false);
    }
  };
  
  const getCleanFileName = (url) => {
    if (!url) return "Report";
  
    const file = decodeURIComponent(url.split("/").pop());
    const parts = file.split("-");
  
    return parts.slice(2).join("-");
  };
  
 console.log("User ID:", userId);
 const patient_id = props.patient_id;
  console.log("Patient ID from reports page:", patient_id);

  return (
    <>
      <div
        className="d-flex justify-content-between px-3 align-items-center "
        style={{ paddingTop: "30px", position: "relative", gap: "12px" }}
        onChange={handleChange}
      >
        <div
          style={{
            fontSize: isTabScreen ? "24px" : "32px",
            textAlign: "left",
            fontSize: isTabScreen ? "24px" : "32px",
            fontWeight: "600",
            fontFamily: "Poppins",
            color: configData.THEME_COLORS.PRIMARY,
          }}
        >
          Reports
        </div>
        <select
          className="form-select"
          onChange={(e) => {
            if (e.target.value == "Select") return;
             setReportType("current");
             filterreports(e.target.value);

            if (e.target.value === "old") {
             setReportType("old");
             fetchOldReports();
             return;
           }

          }}
        >
          <option>Select</option>
          <option value={"all"}>All Reports</option>
          <option value={userId}>My Reports</option>
          <option value={"old"}>Old Reports</option>
          {medicalexperts.length > 0 &&
            medicalexperts.map((item) => {
              return <option value={item.value}>{item.name}</option>;
            })}
        </select>
      </div>
      {/* Reports */}
      {allreports &&
        allreports?.length > 0 &&
        allreports.map((item, index) => {
          return (
            <div
              key={index}
              style={{
                border: "1px solid #E8E7E7",
                margin: "20px 30px",
                borderRadius: "12px",
                backgroundColor: "#F0FAF8",
                padding: "20px",
              }}
            >
              <div
                className="d-flex justify-content-between pb-3"
                style={{ color: "#004AAD" }}
              >
                <div
                  style={{
                    paddingLeft: isTabScreen ? "10px" : "30px",
                    fontSize: isTabScreen ? "10px" : "14px",
                  }}
                >
                  {/* {date} */}
                  {item?.scheduled_date
                    ? moment(item?.scheduled_date).format("YYYY")
                    : ""}
                </div>
                <div
                  style={{
                    paddingRight: isTabScreen ? "10px" : "30px",
                    fontSize: isTabScreen ? "10px" : "14px",
                  }}
                >
                  {/* {week} */}
                  {`WEEK ${item?.week}`}
                </div>
              </div>
              <div
                className="text-center"
                style={{
                  fontSize: isTabScreen ? "16px" : "20px",
                  color: "#F0588B",
                }}
              >
                {/* {title} */}
                {item?.patient_consultation_name ||
                  `Consultation Number ${item?.consultation_number}`}
              </div>
              <div
                style={{
                  fontSize: isTabScreen ? "30px" : "35px",
                  fontWeight: "600",
                  paddingTop: "16px",
                  textAlign: "center",
                  color: "#004AAD",
                }}
              >
                {item?.scheduled_date
                  ? moment(item?.scheduled_date).format("DD MMM")
                  : ""}
              </div>
              <div
                className="py-2"
                style={{
                  fontSize: isTabScreen ? "12px" : "14px",
                  color: "#333333",
                  width: "100%",
                  textAlign: "left",
                }}
              >
                Doctor's Name:{" "}
                <strong>
                  {item?.doctor_fname} {item?.doctor_fname && ` ` + item?.doctor_lname}
                </strong>
              </div>
              <div
                className="py-2"
                style={{
                  fontSize: isTabScreen ? "12px" : "14px",
                  color: "#333333",
                  width: "100%",
                  textAlign: "left",
                }}
              >
                Expertise: <strong>{item?.medical_expert_name}</strong>
              </div>
              <div
                style={{
                  fontSize: isTabScreen ? "13px" : "16px",
                  fontWeight: "400",
                  textAlign: "center",
                }}
              >
                {item?.summary || item?.description || "No Summary"}
              </div>
              <div className="d-flex align-items-center justify-content-center mr-2">
                {item?.is_prescription != 0 && (
                  <button
                    className="btn btn-primary text-center m-auto btn-sm"
                    onClick={() => {
                      // console.log("Console", item?.filekey);
                      props.viewprescriptions(item);
                    }}
                  >
                    View Prescription
                  </button>
                )}
                {item?.filekey && (
                  <button
                    className="btn btn-primary text-center m-auto btn-sm"
                    onClick={() => {
                      // console.log("Console", item?.filekey);
                      props.downloadfiles(item?.filekey);
                    }}
                  >
                    View Report
                  </button>
                )}
              </div>
              {/* <div
                className="d-flex justify-content-center py-3 align-items-center"
                style={{ fontSize: isTabScreen ? "12px" : "14px" }}
              >
                <div>Prescription</div>
              </div> */}
              {/* <div
                className="d-flex justify-content-center py-3 align-items-center"
                style={{ fontSize: isTabScreen ? "12px" : "14px" }}
              >
                <div>Report</div>
              </div> */}
            </div>
          );
        })}

         {/* Old Report */}

         {reportType === "old" && (
           <>
             {loadingOldReports && (
               <div className="text-center">Loading old reports...</div>
             )}
         
             {!loadingOldReports && oldReports.length === 0 && (
               <div className="text-center">No Old Reports Found</div>
             )}
         
             {!loadingOldReports &&
               oldReports.map((item, index) => (
                 <div
                   key={index}
                   style={{
                     border: "1px solid #E8E7E7",
                     margin: "20px 30px",
                     borderRadius: "12px",
                     backgroundColor: "#FFF",
                     padding: "20px",
                     textAlign: "center",
                   }}
                 >
                   <div style={{ fontWeight: 600, color: "#004AAD" }}>
                      {getCleanFileName(item.fileUrl)}
                   </div>

                    {/* PDF PREVIEW */}
                    <iframe
                      src={`${item.fileUrl}#page=1&toolbar=0&navpanes=0`}
                      style={{
                        width: "100%",
                        height: "220px",
                        borderRadius: "8px",
                        border: "1px solid #ddd",
                        marginBottom: "12px",
                      }}
                      title="PDF Preview"
                    />
                    
                   <div className="mt-3">
                     <button
                       className="btn btn-primary btn-sm"
                       onClick={() => {
                         window.open(item.fileUrl, "_blank");
                       }}
                     >
                       View Report
                     </button>
                   </div>
                 </div>
               ))}
           </>
         )}

      {allreports.length == 0 && (
        <div
          style={{
            fontSize: isTabScreen ? "16px" : "20px",
            textAlign: "center",

            fontFamily: "Poppins",
            color: configData.THEME_COLORS.PRIMARY,
          }}
        >
          No Reports Found
        </div>
      )}
    </>
  );
};

export default Reports;
